import { createAction } from 'redux-actions';

export const toggleMeasurementForm = createAction(
  'PRODUCTION_UNIT_MEASUREMENT_TOGGLE'
);

export const selectMeasurement = createAction('REGISTER_SELECT_MEASUREMENT');
